/* eslint-disable max-len */
import React from 'react'
import Helpers from '../Helpers.js'
import {connect} from 'react-redux'
import {storePayload} from '../actions/storePayload.js'
import Footer from './Footer'
import alfredSchema from '../software_schema_3.json'
import {Modal} from '@lazarusai/forms-ui-components'
import '../styles/PathSelectPage.css'

function PathSelectPage(props) {
  function checkForLocalStorage(cb) {
    const dataInProgress = localStorage.getItem('dataInProgress')
    const localDataInProgress = localStorage.getItem('localDataInProgress')
    const dataSavedAt = localStorage.getItem('dataSavedAt')
    const payload = {
      dataInProgress,
      localDataInProgress,
      dataSavedAt,
    }
    if (dataInProgress && localDataInProgress) {
      payload.isLocalStorageModal = true
      payload.isLocalStorageModalShowing = true
    } else {
      cb()
    }
    props.storePayload(payload)
  }

  function handleLocalStorage(cb) {
    const jsDataInProgress = JSON.parse(props.dataInProgress)
    const jsLocalDataInProgress = JSON.parse(props.localDataInProgress)
    handleResponse(jsDataInProgress, jsLocalDataInProgress)
    props.storePayload({
      isLocalStorageModalShowing: false,
    })
    cb()
  }

  async function handleResponse(res, res2) {
    await props.storePayload({
      prompt1Response: res,
      localPrompt1Response: res2,
    })
  }

  function onClickContinue() {
    // To do: make dynamic
    if (props.selectedPath === 'Software Acquisition') {
      checkForLocalStorage(() => {
        props.storePayload({
          step: 'section-select',
        })
      })
    } else if (props.selectedPath === 'Middle Tier of Acquisition') {
      props.storePayload({
        step: 'middle-tier',
      })
    }
  }

  function onClickBack() {
    props.storePayload({
      step: 'file-upload',
    })
  }

  function onClickPath(pathName) {
    if (pathName === 'Middle Tier of Acquisition') {
      props.storePayload({
        path: 'aqcuis-path',
      })
    } else if (pathName === 'Software Acquisition') {
      props.storePayload({
        prompt1Response: alfredSchema,
      })
    }
    props.storePayload({
      selectedPath: pathName,
      // prompt1Response,
    })
  }

  const paths = {
    'Software Acquisition': `The program's objective is to rapidly and iteratively deliver software capability, integrate modern software development practices like Agile, DevSecOps, and Lean, utilize cross-functional teams, and leverage automated tools for development, testing, and deployment to meet the highest priority user needs.`,
    'Middle Tier of Acquisition': 'The program’s objective is to field capabilities to fulfill urgent existing and/or emerging operational needs or quick reactions in less than 2 years.',
    'Major Capability Acquisition': 'The program’s objective is to acquire and/or modernize military unique programs that provide enduring capability, following a structured approach tailored to program size, complexity, risk, and urgency, while integrating software-intensive components and overall major capability pathways.',
    'Urgent Capability Acquistion': 'The program’s objective is to field capabilities to fulfill urgent existing and/or emerging operational needs or quick reactions in less than 2 years.',
    'Acquisition of Services': 'The program’s objective is to acquire services from the private sector including knowledge-based, construction, electronics and communications, equipment, facilities, product support, logistics, medical, research and development, and transportation services.',
    'Defense Business Systems': 'The program’s objective is to acquire information systems for DoD business operations, assessing existing commercial or government solutions, aligning business processes with IT best practices, and minimizing customization while utilizing commercial-off-the-shelf software to reduce risk and maximize benefits.',
  }

  const supportedPaths = [0, 1]

  return (
    <div id='path-select-page'>
      {props.isLocalStorageModal &&
        <Modal
          isVisible={props.isLocalStorageModalShowing}
          theme={props.theme}
          height={'90vh'}
          width={600}
          showConfirm={true}
          showCancel={true}
          // showClose={false}
          outsideClickDismisses={false}
          onCancel={() => {
            props.storePayload({
              isLocalStorageModalShowing: false,
              step: 'section-select',
            })
          }}
          onConfirm={() => {
            handleLocalStorage(() => {
              props.storePayload({
                step: 'section-select',
              })
            })
          }}
          confirmText='Yes'
          cancelText='No'
        >
          <p>
            {`Would you like to restore progress from
            ${Helpers.timeStampToDate(parseInt(props.dataSavedAt))} at
            ${Helpers.timeStampToTime(parseInt(props.dataSavedAt))}?`}
          </p>
          <p>{`Choosing "No" will erase saved progress.`}</p>
        </Modal>
      }
      <div id='path-select-content'>
        <header>
          <h2>
            Select Acquisition Pathway
          </h2>
          <p>
            Select the pathway that best fits your project needs. If applicable, options to add or transition across pathways will be presented on the next page.
          </p>
        </header>
        <main id='paths-container'>
          {Object.keys(paths).map((pathName, i) => {
            const pathDescrip = paths[pathName]
            const isSelected = props.selectedPath === pathName
            const isSupported = supportedPaths.indexOf(i) !== -1
            const extraClass =
              !isSupported ?
                'disabled' :
                isSelected ?
                  'selected' :
                  ''
            return (
              <div
                className={`path-card ${extraClass}`}
                key={pathName + i}
                onClick={() => {
                  if (isSupported) {
                    onClickPath(pathName)
                  }
                }}
              >
                <h6>{pathName}</h6>
                <p>{pathDescrip}</p>
              </div>
            )
          })}
        </main>
      </div>
      <Footer
        onClickContinue={props.selectedPath ? onClickContinue : null}
        onClickBack={onClickBack}
        theme={props.theme}
      />
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  cookies: ownProps.cookies,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  prompt1Response: state.userReducer.prompt1Response,
  isLoading: state.userReducer.isLoading,
  selectedPath: state.userReducer.selectedPath,
  theme: state.userReducer.theme,
  step: state.userReducer.step,
  isLocalStorageModal: state.userReducer.isLocalStorageModal,
  isLocalStorageModalShowing: state.userReducer.isLocalStorageModalShowing,
  dataSavedAt: state.userReducer.dataSavedAt,
  dataInProgress: state.userReducer.dataInProgress,
  localDataInProgress: state.userReducer.localDataInProgress,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(PathSelectPage)
